import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
import { SchoolService } from "../../../shared/services/school.service";
//Import Custom Services Here
import { NumTardiesService } from "../report-services/num-tardies.service";
import { NumAbsentsService } from "../report-services/num-absents.service";
import { NumCutsService } from "../report-services/num-cuts.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import * as moment from "moment";

@Component({
	templateUrl: "./cutsabsencetardy.component.html",
})
export class CutsAbsenceTardyComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		private schoolService: SchoolService,
		//Insert Custom Services Here
		private numcutsService: NumCutsService,
		private numabsentsService: NumAbsentsService,
		private numtardiesService: NumTardiesService,
		private dialogService: DialogService
	) {}
	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		SchoolXML: "",
		StartDate: new Date(),
		EndDate: new Date(),
		NumTardiesID: 0,
		NumAbsentsID: 0,
		NumCutsID: 0,
		ShowDetailID: "Yes",
		OrderByID: "Cuts",
		ImageLogo: "",
	};
	//Insert Custom Lists Here
	NumTardiesList: any = [];
	NumAbsentsList: any = [];
	NumCutsList: any = [];
	ImageLogoList: any = [];
	schoolList: any = [];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ShowDetailList = [
		//Insert Custom List Items Here
		{
			ShowDetailID: "Yes",
			ShowDetailName: "Yes",
		},
		{
			ShowDetailID: "No",
			ShowDetailName: "No",
		},
	];

	OrderByList = [
		//Insert Custom List Items Here
		{
			OrderByID: "Cuts",
			OrderByName: "Cuts",
		},
		{
			OrderByID: "Absences",
			OrderByName: "Absences",
		},
		{
			OrderByID: "Lates",
			OrderByName: "Lates",
		},
		{
			OrderByID: "Name",
			OrderByName: "Name",
		},
		{
			OrderByID: "Academy",
			OrderByName: "Academy",
		},
		{
			OrderByID: "Grade",
			OrderByName: "Grade",
		},
		{
			OrderByID: "Homeroom",
			OrderByName: "Homeroom",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 8;
	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadSchoolist()
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.report.SchoolID = school.SchoolID;
			this.loadLogolist();
		});

		this.loadNumTardiesList();
		this.loadNumAbsentsList();
		this.loadNumCutsList();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(8);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.report.SchoolID = this.schoolList[0].SchoolID;
					//this.GroupList()
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	private loadNumTardiesList() {
		this.report.NumTardiesID = 0;

		this.NumTardiesList = [];

		for (var i = 0; i <= 100; i++) {
			let nextEntry = {
				ID: i,
				Description: i.toString(),
			};
			this.NumTardiesList.push(nextEntry);
		}

		// var result = this.numtardiesService.loadNumTardiesList(0, this.report.SchoolID);
		// result.subscribe(
		//     response => {
		//         this.NumTardiesList = response;

		//         this.report.NumTardiesID = this.NumTardiesList[0].NumTardiesID

		//     },
		//     error => {
		//     }
		// )
	}

	private loadNumAbsentsList() {
		this.report.NumAbsentsID = 0;
		this.NumAbsentsList = [];

		for (var i = 0; i <= 100; i++) {
			let nextEntry = {
				ID: i,
				Description: i.toString(),
			};
			this.NumAbsentsList.push(nextEntry);
		}

		// var result = this.numabsentsService.loadNumAbsentsList(0, this.report.SchoolID);
		// result.subscribe(
		//     response => {
		//         this.NumAbsentsList = response;

		//         this.report.NumAbsentsID = this.NumAbsentsList[0].NumAbsentsID

		//     },
		//     error => {
		//     }
		// )
	}

	private loadNumCutsList() {
		this.report.NumCutsID = 0;

		this.NumCutsList = [];

		for (var i = 0; i <= 100; i++) {
			let nextEntry = {
				ID: i,
				Description: i.toString(),
			};
			this.NumCutsList.push(nextEntry);
		}

		// var result = this.numcutsService.loadNumCutsList(0, this.report.SchoolID);
		// result.subscribe(
		//     response => {
		//         this.NumCutsList = response;

		//         this.report.NumCutsID = this.NumCutsList[0].NumCutsID

		//     },
		//     error => {
		//     }
		//)
	}
	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		// if (!this.report.SchoolID) {
		// 	this.errorMessage = "Select the School"
		// 	return;
		// }

		// if (!this.report.StartDate) {
		// 	this.errorMessage = "Select the StartDate"
		// 	return;
		// }

		// if (!this.report.EndDate) {
		// 	this.errorMessage = "Select the EndDate"
		// 	return;
		// }

		// if (!this.report.NumTardiesID) {
		// 	this.errorMessage = "Select the NumTardies"
		// 	return;
		// }

		// if (!this.report.NumAbsentsID) {
		// 	this.errorMessage = "Select the NumAbsents"
		// 	return;
		// }

		// if (!this.report.NumCutsID) {
		// 	this.errorMessage = "Select the NumCuts"
		// 	return;
		// }

		// if (!this.report.ShowDetailID) {
		// 	this.errorMessage = "Select the ShowDetail"
		// 	return;
		// }

		// if (!this.report.OrderByID) {
		// 	this.errorMessage = "Select the OrderBy"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 8;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolXML
		strParam += "<ROOT><School SchoolID='" + this.report.SchoolID + "'/></ROOT>" + "|SchoolXML";

		//Parameter 2: StartDate
		strParam += "," + moment(this.report.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 3: EndDate
		strParam += "," + moment(this.report.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 4: NumTardies
		strParam += "," + this.report.NumTardiesID + "|NumTardies";

		//Parameter 5: NumAbsents
		strParam += "," + this.report.NumAbsentsID + "|NumAbsents";

		//Parameter 6: NumCuts
		strParam += "," + this.report.NumCutsID + "|NumCuts";

		//Parameter 7: ShowDetail
		strParam += "," + this.report.ShowDetailID + "|ShowDetail";

		//Parameter 8: OrderBy
		strParam += "," + this.report.OrderByID + "|OrderBy";

		//Parameter 9: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
